// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 60px;
  padding: 0 1.75rem;
  background: #fff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid var(--border);
}

.admin-header-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--text);
  font-size: 1.15rem;
  transition: background 0.2s, color 0.2s;
}

.admin-header-toggle:hover {
  background: var(--main-bg);
  color: var(--primary);
}

.admin-header-spacer {
  flex: 1 1;
}

.admin-header-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.4rem 0.75rem 0.4rem 0.4rem;
  border-radius: 999px;
  background: var(--main-bg);
  border: 1px solid var(--border);
}

.admin-header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  font-weight: 700;
}

.admin-header-user-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.admin-header-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text);
}

.admin-header-role {
  font-size: 0.72rem;
  color: var(--text-muted);
  margin-top: 0.05rem;
}

/* Logout button – visible on mobile where sidebar logout may be off-screen */
.admin-header-logout {
  display: none;
}

@media (max-width: 992px) {
  .admin-header-logout {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.85rem;
    border: none;
    border-radius: var(--radius-sm);
    background: linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%);
    color: #fff;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
  }

  .admin-header-logout:hover {
    background: linear-gradient(135deg, #b91c1c 0%, #dc2626 50%, #ef4444 100%);
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qCAAqC;EACrC,oBAAoB;EACpB,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,+BAA+B;IAC/B,0EAA0E;IAC1E,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,0EAA0E;IAC1E,6CAA6C;EAC/C;AACF","sourcesContent":[".admin-header {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  height: 60px;\n  padding: 0 1.75rem;\n  background: #fff;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  border-bottom: 1px solid var(--border);\n}\n\n.admin-header-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  padding: 0;\n  border: none;\n  border-radius: var(--radius-sm);\n  background: transparent;\n  color: var(--text);\n  font-size: 1.15rem;\n  transition: background 0.2s, color 0.2s;\n}\n\n.admin-header-toggle:hover {\n  background: var(--main-bg);\n  color: var(--primary);\n}\n\n.admin-header-spacer {\n  flex: 1;\n}\n\n.admin-header-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.4rem 0.75rem 0.4rem 0.4rem;\n  border-radius: 999px;\n  background: var(--main-bg);\n  border: 1px solid var(--border);\n}\n\n.admin-header-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.admin-header-user-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.admin-header-name {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.admin-header-role {\n  font-size: 0.72rem;\n  color: var(--text-muted);\n  margin-top: 0.05rem;\n}\n\n/* Logout button – visible on mobile where sidebar logout may be off-screen */\n.admin-header-logout {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .admin-header-logout {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 0.85rem;\n    border: none;\n    border-radius: var(--radius-sm);\n    background: linear-gradient(135deg, #dc2626 0%, #ef4444 50%, #f87171 100%);\n    color: #fff;\n    font-size: 0.85rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n  }\n\n  .admin-header-logout:hover {\n    background: linear-gradient(135deg, #b91c1c 0%, #dc2626 50%, #ef4444 100%);\n    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.35);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
